<template>
  <div class="skill">
    <div class="tab-list">
      <div
        class="tab-item"
        v-for="(key, index) in Object.keys(dataSource.list)"
        :class="{ 'tab-item-active': active == index }"
        :key="key + index"
        @click="handleTabChange(index)"
      >
        <img class="icon" :src="dataSource.list[key].icon.value" />
        <span class="name"> {{ index === 2 ? "爆裂" : dataSource.list[key].type.value }}技能 </span>
        <!-- <span class="name-en">{{ index < 2 ? "Passive skill" : "Burst skill" }}</span> -->
      </div>
      <div class="tab-item" :class="{ 'tab-item-active': active == 3 }" @click="handleTabChange(3)">
        <img class="icon" :src="dataSource.ptgj.icon.value" />
        <span class="name">{{ dataSource.ptgj.name.value }}</span>
        <!-- <span class="name-en">Normal attack</span> -->
      </div>
      <div
        class="tab-item"
        :class="{ 'tab-item-active': active == 4 }"
        @click="handleTabChange(4)"
        v-if="dataSource.zcp.icon.hasValue && dataSource.zcp.icon.value"
      >
        <img class="icon" :src="dataSource.zcp.icon.value" />
        <span class="name">{{ dataSource.zcp.name.value }}</span>
        <!-- <span class="name-en">Collection</span> -->
      </div>
    </div>
    <ElScrollbar
      style="overflow-y: auto; padding-bottom: 40px;height: 640px;"
      wrapStyle="overflow-x: hidden;  display: flex; flex-direction: column;"
      viewStyle="padding: 4px 0; flex-grow: 1;"
    >
      <div class="skill-background" :style="{ height: hasSkinEvalution ? 'auto' : '100%' }">
        <div class="skill-container" :style="{ height: hasSkinEvalution ? 'auto' : '100%' }">
          <!-- 主/被动技能 -->
          <template v-if="[0, 1, 2].includes(active)">
            <div class="skill-header">
              <div class="skill-caption-layout left">
                <div class="icon-box">
                  <img class="icon" :src="currentSkill.icon.value" />
                </div>
                <div class="attr-box">
                  <div class="skill-name">
                    <span class="txt">{{ currentSkill.name.value }}</span>
                    <span class="diff" @click="handleSkillDiff">[ 技能对比 ·]</span>
                  </div>
                  <div class="line"></div>
                  <div class="cd">CD：{{ currentSkill.cd.value }}</div>
                </div>
              </div>
              <div class="right">
                <div
                  :class="['increase', activeLevel <= minLevel ? 'disabled' : '']"
                  @click="handleLevelChange(activeLevel - 1)"
                >
                  -
                </div>
                <div class="level-num">LV {{ activeLevel }}</div>
                <div
                  :class="['decrease', activeLevel >= maxLevel ? 'disabled' : '']"
                  @click="handleLevelChange(activeLevel + 1)"
                >
                  +
                </div>
              </div>
            </div>
            <div class="skill-body">
              <template v-if="currentSkillLevel">
                <!-- 技能描述 -->
                <div
                  v-html="formatText(currentSkillLevel.desc.value, notes)"
                  style="margin-bottom: 14px; line-height: 1.8;"
                ></div>
                <!-- 升级材料 -->
                <template
                  v-if="
                    !Object.keys(currentSkillLevel.upgrade)
                      .slice(0, 4)
                      .every(key => !currentSkillLevel.upgrade[key].icon.hasValue)
                  "
                >
                  <div class="caption shengji">升级材料</div>
                  <div class="shengji-list">
                    <template v-for="(key, index) in Object.keys(currentSkillLevel.upgrade).slice(0, 4)">
                      <div
                        v-if="currentSkillLevel.upgrade[key].icon.hasValue && currentSkillLevel.upgrade[key].icon.value"
                        :key="index"
                        class="shengji-item"
                      >
                        <img class="icon" :src="currentSkillLevel.upgrade[key].icon.value" />
                        <span class="num">+{{ currentSkillLevel.upgrade[key].num.value }}</span>
                      </div>
                    </template>
                  </div>
                </template>
              </template>
              <!-- 珍藏品 -->
              <template v-if="currentSkill.zpqh.desc && currentSkill.zpqh.desc.value">
                <div class="caption cangpin">珍藏品</div>
                <div class="cangpin-text" v-html="formatText(currentSkill.zpqh.desc.value, notes)"></div>
              </template>
            </div>
          </template>
          <!-- 普通攻击 -->
          <template v-if="active === 3">
            <div class="skill-caption-layout">
              <div class="icon-box">
                <img class="icon" :src="dataSource.ptgj.weapon.icon.value" />
              </div>
              <div class="attr-box">
                <div class="skill-name">
                  <span class="txt"
                    >{{ dataSource.ptgj.weapon.name.value }}（{{ dataSource.ptgj.list.l4.value.value }}）</span
                  >
                </div>
                <div class="line"></div>
                <div class="cd">CD：{{ currentSkill.cd.value }}</div>
              </div>
            </div>
            <div class="skill-body">
              <div class="skill-attr-wrapper">
                <div class="skill-attr">最大装弹数：{{ dataSource.ptgj.list.l1.value.value }}</div>
                <div class="skill-attr">操作类型：{{ dataSource.ptgj.list.l3.value.value }}</div>
              </div>
              <!-- <div class="caption cangpin">收藏品</div> -->
              <div class="cangpin-text" v-html="formatText(dataSource.ptgj.list.l5.value.value, notes)"></div>
            </div>
          </template>
          <!-- 珍藏品 -->
          <template v-if="active === 4">
            <div class="skill-caption-layout">
              <div class="icon-box">
                <img class="icon" :src="dataSource.zcp.weapon.icon.value" />
              </div>
              <div class="attr-box">
                <div class="skill-name">
                  <span class="txt">{{ dataSource.zcp.weapon.name.value }}</span>
                </div>
                <div class="line"></div>
                <div class="cd">收集品</div>
              </div>
            </div>
            <div class="skill-body">
              <div class="skill-attr-wrapper">
                <div class="skill-attr">体力：{{ dataSource.zcp.list.l1.value.value }}</div>
                <div class="skill-attr">攻击力：{{ dataSource.zcp.list.l2.value.value }}</div>
                <div class="skill-attr">防御力：{{ dataSource.zcp.list.l3.value.value }}</div>
              </div>
              <div class="caption cangpin">珍藏品介绍</div>
              <template v-if="dataSource.zcp.desc">
                <div class="cangpin-text">{{ dataSource.zcp.desc.value }}</div>
              </template>
            </div>
          </template>
        </div>
      </div>
      <!-- 攻略 -->
      <div v-if="hasSkinEvalution" style="margin: 16px 16px 0;">
        <SkinEvalution :key="currentStyle.key" :dataSource="currentStyle.evaluation" />
      </div>
    </ElScrollbar>
    <NotesPoppover ref="notesPoppover" />
    <el-dialog :visible.sync="visible" title="技能对比" width="500px" custom-class="dialog-custom-class" append-to-body>
      <div class="tab-list" style="background: none; height: 80px; padding: 0; justify-content: center;">
        <div
          class="tab-item"
          v-for="(key, index) in Object.keys(dataSource.list)"
          :class="{ 'tab-item-active': active == index }"
          :key="key + index"
          @click="handleTabChange(index)"
        >
          <img class="icon" :src="dataSource.list[key].icon.value" />
          <span class="name"> {{ index == 2 ? "爆裂" : dataSource.list[key].type.value }}技能 </span>
          <!-- <span class="name-en">{{ index < 2 ? "Passive skills" : "Active skills" }}</span> -->
        </div>
      </div>
      <div class="skill-container" style="margin: 0;">
        <div class="skill-header">
          <div class="skill-caption-layout left">
            <div class="icon-box">
              <img class="icon" :src="currentSkill.icon.value" />
            </div>
            <div class="attr-box">
              <div class="skill-name">
                <span class="txt">{{ currentSkill.name.value }}</span>
              </div>
              <div class="line"></div>
              <div class="cd">CD：{{ currentSkill.cd.value }}</div>
            </div>
          </div>
        </div>
        <el-scrollbar style="height: 50vh; margin-top: 14px;" wrapStyle="overflow-x: hidden;">
          <div class="skill-body" style="margin-top: 0;">
            <template v-if="dataSource.list['s' + (active + 1)]">
              <div v-for="(level, key) of dataSource.list['s' + (active + 1)].level" :key="key" class="skill-diff-item">
                <div class="caption shengji">Lv.{{ key.replace("l", "") }}</div>
                <template v-if="level">
                  <div v-html="formatText(level.desc.value, notes)" style="margin-top: 14px;"></div>
                  <div class="shengji-list">
                    <template v-for="(key, index) in Object.keys(level.upgrade).slice(0, 4)">
                      <div
                        v-if="key !== 'l1' && level.upgrade[key].icon.hasValue && level.upgrade[key].icon.value"
                        :key="index"
                        class="shengji-item"
                      >
                        <img class="icon" :src="level.upgrade[key].icon.value" />
                        <span class="num">+{{ level.upgrade[key].num.value }}</span>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </el-scrollbar>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { throttle } from "@/plugins/util";
import { formatText } from "../../utils";
import NotesPoppover from "../../components/NotesPoppover.vue";
import SkinEvalution from "./skinEvalution.vue";

export default {
  name: "Skill",
  components: { NotesPoppover, SkinEvalution },
  props: {
    dataSource: { type: Object, default: () => ({}) },
    currentStyle: { type: Object, default: () => ({}) },
    notes: { typeof: Array, default: () => ({}) }
  },
  data() {
    return {
      visible: false,
      active: 0,
      activeLevel: 10,
      showSkillCompare: false,
      currentSkill: this.dataSource.list["s1"],
      currentSkillLevel: this.dataSource.list["s1"].level["l10"],
      skillLevelCache: {},
      minLevel: 0,
      maxLevel: 0
    };
  },
  computed: {
    hasSkinEvalution() {
      return Object.values(this.currentStyle.evaluation).some(item => {
        return item.cover.hasValue && item.title.hasValue && item.cover.value && item.title.value;
      });
    }
  },
  watch: {
    dataSource: {
      handler(val) {
        if (this.active == 0) this.currentSkill = this.dataSource.list["s1"];
        else if (this.active == 1) this.currentSkill = this.dataSource.list["s2"];
        else if (this.active == 2) this.currentSkill = this.dataSource.list["s3"];
      },
      deep: true,
      immediate: true
    },
    currentSkill: {
      handler(val) {
        this.activeLevel = this.skillLevelCache[this.active + ""] || 10;
        this.currentSkillLevel = val.level["l" + this.activeLevel];
        this.initPoppover();
        this.setMinMaxLevel();
      },
      deep: true
    }
  },
  mounted() {
    this.initPoppover();
    this.setMinMaxLevel();
  },
  methods: {
    formatText,
    initPoppover() {
      this.$nextTick(() => {
        const noteEls = document.querySelectorAll("[data-notes-value]");
        noteEls.forEach(el => {
          el.addEventListener("mouseenter", () => {
            this.$refs.notesPoppover.open(el, el.dataset.notesValue);
          });
        });
      });
    },
    handleTabChange(active) {
      this.active = active;
      this.activeLevel = 10;
      this.showSkillCompare = false;
      if (active == 0) this.currentSkill = this.dataSource.list["s1"];
      else if (active == 1) this.currentSkill = this.dataSource.list["s2"];
      else if (active == 2) this.currentSkill = this.dataSource.list["s3"];
      this.initPoppover();
    },
    triggerCompare() {
      this.showSkillCompare = !this.showSkillCompare;
    },
    handleLevelChange(level) {
      if (level < this.minLevel || level > this.maxLevel) return;
      this.activeLevel = level;
      this.currentSkillLevel = this.currentSkill.level["l" + level];
      this.initPoppover();
      this.skillLevelCache[this.active + ""] = this.activeLevel;
    },
    isSub(level) {
      return this.activeLevel - 1 == level || this.activeLevel + 1 == level;
    },
    handleLevelMouseWheel: throttle(function(e) {
      let level = this.activeLevel;
      if (e.deltaY > 0) {
        level += 1;
      } else {
        level -= 1;
      }
      this.handleLevelChange(level);
    }, 300),
    handleSkillDiff() {
      this.visible = true;
    },
    setMinMaxLevel() {
      const levels = Object.keys(this.currentSkill.level).map(value => Number(value.replace("l", "")));
      const min = Math.min(...levels);
      const max = Math.max(...levels);
      this.minLevel = min;
      this.maxLevel = max;
    }
  }
};
</script>
<style lang="less" scoped>
.skill {
  position: relative;
  z-index: 3;
  flex-grow: 1;
  width: 660px;
  padding: 14px 0;
  background: url("~@/assets/nikke_imgs/skill-bg.png") center/100% 100% no-repeat;
  display: flex;
  flex-direction: column;
  .skill-background {
    padding-bottom: 6px;
  }
}
.tab-list {
  display: flex;
  padding: 0 30px;
  justify-content: space-between;
  margin-bottom: 14px;
  .tab-item {
    position: relative;
    width: 120px;
    height: 57px;
    background: url("~@/assets/nikke_imgs/skill-icon-bg.png") left 12px center / 36px 37px no-repeat,
      url("~@/assets/nikke_imgs/skill-item-normal.png") center / 100% 100% no-repeat;
    color: rgba(20, 38, 48, 0.7);
    cursor: pointer;
    &:first-child {
      background: url("~@/assets/nikke_imgs/skill-icon-bg-active.png") left 12px center / 36px 37px no-repeat,
        url("~@/assets/nikke_imgs/skill-item-normal-first.png") center / 100% 100% no-repeat;
    }
    .icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 16px;
      width: 28px;
      height: 28px;
      object-fit: contain;
      object-position: center;
      border-radius: 50%;
    }
    .name {
      position: absolute;
      left: 48px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 13px;
      margin-left: 4px;
    }
    /* .name-en {
      position: absolute;
      left: 46px;
      top: 32px;
      font-size: 13px;
      white-space: nowrap;
    } */
  }
  .tab-item-active {
    background: url("~@/assets/nikke_imgs/skill-icon-bg-active.png") left 12px center / 36px 37px no-repeat,
      url("~@/assets/nikke_imgs/skill-item-active.png") center / 100% 100% no-repeat;
    color: #3eaffe;
    &:first-child {
      background: url("~@/assets/nikke_imgs/skill-icon-bg-active.png") left 12px center / 36px 37px no-repeat,
        url("~@/assets/nikke_imgs/skill-item-active.png") center / 100% 100% no-repeat;
    }
  }
}
.skill-container {
  /* box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15), inset 8px -8px 8px 0px #ffffff, inset -8px 8px 8px 0px #ffffff; */
  border-radius: 4px;
  padding: 0 16px;
  margin: 0 12px 0 16px;
  /* background: rgba(255, 255, 255, 0.45); */
  .skill-caption-layout {
    display: flex;
    .icon-box {
      /* width: 46px; */
      width: 0;
      overflow: hidden;
      height: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url("~@/assets/nikke_imgs/skill-icon-bg.png") center/contain no-repeat;
      .icon {
        width: 34px;
        height: 34px;
        border-radius: 50%;
      }
    }
    .attr-box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .skill-name {
        display: flex;
        align-items: center;
        .txt {
          color: #142630;
          font-size: 15px;
        }
        .diff {
          margin-left: 12px;
          color: #3eaffe;
          font-size: 12px;
          cursor: pointer;
        }
      }
      /* .line {
        width: 405px;
        height: 1px;
        background: linear-gradient(90deg, #142630 0%, rgba(20, 38, 48, 0) 100%);
        opacity: 0.2;
      } */
      .cd {
        font-size: 12px;
        background-color: #808080;
        line-height: 22px;
        padding: 0 10px;
        width: fit-content;
        color: #fff;
      }
    }
  }
  .skill-header {
    display: flex;
    .left {
      flex-grow: 1;
    }
    .right {
      display: flex;
      column-gap: 18px;
      align-items: center;
      .increase,
      .decrease {
        width: 24px;
        height: 24px;
        text-align: center;
        background-color: rgba(20, 38, 48, 0.9);
        color: #fff;
        user-select: none;
        cursor: pointer;
      }
      .level-num {
        width: 48px;
        text-align: center;
        color: rgba(20, 38, 48, 0.9);
        font-size: 14px;
      }
      .disabled {
        background-color: #d9d9d9;
      }
    }
  }
  .skill-body {
    margin-top: 16px;
    .skill-diff-item {
      display: grid;
      grid-template-columns: 50px auto;
      .caption {
        grid-row-start: span 2;
        margin: 0;
        padding-top: 14px;
        &::after {
          width: 380px;
          right: -350px;
          background-image: linear-gradient(
            to right,
            rgba(223, 226, 227, 1),
            rgba(223, 226, 227, 1) 80%,
            rgba(223, 226, 227, 0)
          );
          background-color: unset;
        }
      }
    }
    .caption {
      position: relative;
      color: rgba(20, 38, 48, 0.9);
      font-size: 14px;
      width: fit-content;
      margin-left: 40px;
      &::before {
        content: "";
        position: absolute;
        width: 24px;
        height: 3px;
        left: -40px;
        bottom: 6px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
      &::after {
        content: "";
        position: absolute;
        width: 237px;
        height: 1px;
        right: -244px;
        bottom: 6px;
        background-color: #cacdd0;
      }
    }
    .shengji::before {
      background-image: url("~@/assets/nikke_imgs/skill-detail-shengji.png");
    }
    .cangpin::before {
      background-image: url("~@/assets/nikke_imgs/skill-detail-cangpin.png");
    }
    .shengji-list {
      display: flex;
      padding: 14px 2px;
      column-gap: 8px;
      .shengji-item {
        display: flex;
        align-items: center;
        background-color: rgba(51, 51, 51, 0.05);
        border-radius: 2px;
        padding: 0 8px;
        .icon {
          width: 32px;
          height: 32px;
        }
        .num {
          color: #142630;
          font-size: 14px;
        }
      }
    }
    .cangpin-text {
      padding: 14px 0;
      line-height: 1.8;
    }
    .skill-attr-wrapper {
      display: flex;
      column-gap: 20px;
      margin-bottom: 14px;
      .skill-attr {
        width: 148px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: url("~@/assets/nikke_imgs/skill-attr-bg.png") center/contain no-repeat;
        color: #ffffff;
        font-size: 14px;
      }
    }
  }
}

/deep/ .dialog-custom-class {
  background-color: #eff0f1;
  .el-dialog__header {
    text-align: center;
    .el-dialog__title {
      color: rgba(20, 38, 48, 0.9);
      font-size: 16px;
      font-weight: bold;
    }
    i.el-dialog__close {
      font-weight: bold;
    }
  }
}
</style>
